module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-Italic-a635cd65ecf783265f96542e32ce5c15.ttf";